import { createReducer } from 'redux-act';
import { PURGE } from 'redux-persist';

import {
    hourVisibleUpdate,
    teacherVisibleUpdate,
    roomVisibleUpdate,
    colorVisibleUpdate,
    otherTaskVisibleUpdate,
    timeVisibleUpdate,
    startUpdate,
    endUpdate
} from 'actions/agenda';

let today = new Date();

const defaultState = {
    hour: true,
    teacher: true,
    room: true,
    color: true,
    other_task: true,
    time: true,
    start: today.setDate(today.getDate() - 14),
    end: today.setDate(today.getDate() + 28)
};

const newModule = createReducer({
    [hourVisibleUpdate]: (state, payload) => ({
        ...state,
        hour: !state.hour
    }),
    [teacherVisibleUpdate]: (state, payload) => ({
        ...state,
        teacher: !state.teacher
    }),
    [roomVisibleUpdate]: (state, payload) => ({
        ...state,
        room: !state.room
    }),
    [colorVisibleUpdate]: (state, payload) => ({
        ...state,
        color: !state.color
    }),
    [otherTaskVisibleUpdate]: (state, payload) => ({
        ...state,
        other_task: !state.other_task
    }),
    [timeVisibleUpdate]: (state, payload) => ({
        ...state,
        time: !state.time
    }),
    [startUpdate]: (state, payload) => ({
        ...state,
        start: payload.start
    }),
    [endUpdate]: (state, payload) => ({
        ...state,
        end: payload.end
    }),
    [PURGE]: () => defaultState
}, defaultState);

export default newModule;